module.exports = __webpack_public_path__ + "static/media/depth.ee445afd.frag";